import React, { useEffect, useRef, useState } from 'react';
import '../../Assets/Styles/offCanvas.css';
import { cartAddServiceTimeslot, serviceTimeSlotDetails } from '../../Services/api';
import { useNavigate, useParams } from 'react-router-dom';
import ReactLoading from "react-loading";
import { toast } from 'react-toastify';
import { IoLogoHackernews } from 'react-icons/io';
import bookingconfirm_img from "../../Assets/Images/bookingconfirm.png";

const ReviewAndConfirmOffCanvas = ({ isOpen, date, day, time, section, slot, toggleOffCanvas, resetTimeslot }) => {

    const navigate = useNavigate();
    const bookingconfirm = useRef(null);

    const valueParam = useParams(); // URL parameter hook
    const [reschedule, setReschedule] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [rescheduleconfirm, setRescheduleconfirm] = useState(false)


    useEffect(() => {
        let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
        if (localServiceDetail && localServiceDetail?.reschedule && localServiceDetail?.reschedule == true) {
            setReschedule(true)
        }
    }, []);

    function addServiceTimeSlot() {
        setLoading(true)
        let localServiceDetail = localStorage.getItem('serviceDetail')
            ? JSON.parse(localStorage.getItem('serviceDetail'))
            : '';

        let param = {
            "vendor_id": valueParam.vendor_id,
            "cart_app_id": (localServiceDetail && localServiceDetail?.cart_app_id) ? localServiceDetail?.cart_app_id : '',
            "booking_type": (localServiceDetail && localServiceDetail?.reschedule && localServiceDetail?.reschedule == true) ? "2" : "1",
            "date": date,
            "time_section": section,
            "time_slot": slot,
            "service_type": (localServiceDetail && localServiceDetail?.serviceType) ? localServiceDetail?.serviceType : '',
        };

        cartAddServiceTimeslot(param).then((res) => {
            let localServiceDetail = localStorage.getItem('serviceDetail') ? JSON.parse(localStorage.getItem('serviceDetail')) : '';
            if (localServiceDetail && localServiceDetail?.reschedule && localServiceDetail?.reschedule == true) {
                setRescheduleconfirm(true)
                setLoading(false)
 
                // toggleOffCanvas()

                openRescheduleconfirm()

            } else {
                setLoading(false)
                if (res.data?.status == '1') {
                    const servicetime = localStorage.getItem("localStorageserviceTime")
                    const servicetimes = JSON.parse(servicetime);

                    const updatedStorageData = {
                        date: servicetimes.date,
                        day: servicetimes.day,
                        time: servicetimes.time,
                        section: servicetimes.section,
                        slot: servicetimes.slot,
                        status: false

                    };

                    localStorage.setItem("localStorageserviceTime", JSON.stringify(updatedStorageData));
                    localServiceDetail.timslotStatus = true;
                    localStorage.setItem("serviceDetail", JSON.stringify(localServiceDetail));
                    navigate(`/review-and-pay/${valueParam.vendor_id}`)
                }
            }
        }).catch((error) => {

            if (error.response.status == 400) {

                toast(error.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
                resetTimeslot()
                setLoading(false)
            }
            if (error.response.status == 500) {
                toast('something went wrong please try again', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    className: 'text-danger toast-style-1'
                });
                resetTimeslot()
                setLoading(false)
            }
        })
    }

    const openRescheduleconfirm = () => {
        bookingconfirm.current.classList.add("show");
        bookingconfirm.current.style.display = "block";
        setIsModalOpen(true)

    };

    const closeBookingconfirm = () => {
        bookingconfirm.current.classList.remove("show");
        setIsModalOpen(false)
        localStorage.removeItem("serviceDetail");
        localStorage.removeItem("selectedServiceOption");
        localStorage.removeItem("appliedCard");
        navigate(-1);

    };


    return (
        <>
            {!rescheduleconfirm &&

                <div className={`offcanvas reviewAndConfirmOffCanvas ${isOpen ? 'show' : ''}`} style={{ width: '-webkit-fill-available', marginBottom: 30, display: 'block', zIndex: 9999, position: 'sticky', padding: 10 }} tabindex="-1" aria-labelledby="selectCustomerModalLabel">
                    <div className="small">
                        <div className='d-flex justify-content-center'>
                            <div className='custom-pill'></div>
                        </div>

                        <div className='ff-poppins-semiBold fs-12 text-center m-3'>
                            <span className='primary-text'>{date} </span>
                            <span>{day} - {time}</span>
                        </div>

                        <button type='button'
                            className='btn-type-1 ff-poppins-semiBold fs-14 w-100 primary-bg border-0 text-white  justify-content-center d-flex align-items-center'
                            style={{
                                marginBottom: 45
                            }}
                            onClick={() => { setLoading(true); addServiceTimeSlot() }}
                            disabled={loading}>
                            {loading ? <ReactLoading type={"spinningBubbles"} color={"#fff"} height={20} width={20} /> : reschedule ? "Confirm" : "Review and Confirm"}
                        </button>
                    </div>
                </div>
            }
            <div className={`modal fade`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={bookingconfirm} data-bs-backdrop="false" style={{ backgroundColor: "#fff",zIndex:"10000" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content modal-success" style={{ width: 300 }}>
                        <div className="modal-body justify-content-center mt-3">
                            <div className='d-flex justify-content-center'>
                                <img src={bookingconfirm_img} height="100px" width="130px" />
                            </div>

                            <div className="text-center ff-poppins-semiBold fs-16  primary-text mt-4">
                                Reschedule Completed
                            </div>

                            <div className="text-center ff-poppins-semiBold mt-4 fs-14 ">
                                <p className='p-0 m-0 secondary-text'>  Your  resuchedule  date is</p>
                                <div className='ff-poppins-semiBold fs-12 text-center m-3'>
                                    <span className='primary-text'>{date} </span>
                                    <span>{day} - {time}</span>
                                </div>


                                <button type="button" className="btn rounded-pill ff-poppins-semiBold col-6 primary-bg text-white rounded my-3"
                                    onClick={() => closeBookingconfirm()}
                                    style={{ backgroundColor: '#4e26a3', color: 'white' }}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && <div className="modal-backdrop fade show"></div>}

        </>
    )
};

export default ReviewAndConfirmOffCanvas;